import OwLabel from "@components/shared/OwLabel/OwLabel";
import OwTitle from "@components/shared/OwTitle/OwTitle";
import SupplierContext from "@contexts/SupplierContext";
import IOrder from "@models/IOrder";
import { useContext } from "react";
import { NumericFormat } from "react-number-format";
import "./EcommerceOrderCheckoutSummary.scss";

type Props = {
    order: IOrder;
};

export const EcommerceOrderCheckoutSummary = (props: Props) => {
    const supplierModel = useContext(SupplierContext);

    return (
        <div className={"EcommerceOrderCheckoutSummary"}>
            <table className="table">
                <tbody>
                    <tr>
                        <td>
                            <OwLabel title={"items"} postText={":"} className="me-2" />
                        </td>
                        <td className="text-end">
                            <NumericFormat
                                value={(props.order!.sub_total || 0) - (props.order!.discount_total || 0)}
                                displayType={"text"}
                                thousandSeparator={true}
                                decimalScale={supplierModel.pricing_precision || 2}
                                fixedDecimalScale={true}
                                prefix={"$"}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <OwLabel title={"tax"} postText={":"} />
                        </td>
                        <td className="text-end">
                            <NumericFormat
                                value={props.order!.tax || 0}
                                displayType={"text"}
                                thousandSeparator={true}
                                decimalScale={supplierModel.pricing_precision || 2}
                                fixedDecimalScale={true}
                                prefix={"$"}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <OwLabel title={"shipping"} postText={":"} />
                        </td>
                        <td className="text-end">
                            <NumericFormat
                                value={props.order!.shipping || 0}
                                displayType={"text"}
                                thousandSeparator={true}
                                decimalScale={supplierModel.pricing_precision || 2}
                                fixedDecimalScale={true}
                                prefix={"$"}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <OwLabel title={"order_total"} postText={":"} />
                        </td>
                        <td className="text-end">
                            <NumericFormat
                                value={props.order!.grand_total || 0}
                                displayType={"text"}
                                thousandSeparator={true}
                                decimalScale={supplierModel.pricing_precision || 2}
                                fixedDecimalScale={true}
                                prefix={"$"}
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};
